module.exports = __webpack_public_path__ + "static/media/achievement-silder-shoe.187650af.svg";